module.exports = __webpack_public_path__ + "img/option-2.b875a671.png";